/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon May 27 2024
 **/

import { ModalPopup, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

interface CancelWritingConfirmProps {
	modalID: string;
	onConfirm: (ev: React.MouseEvent | KeyboardEvent, hide: () => void) => void;
}

export default function CancelWritingConfirm(props: CancelWritingConfirmProps) {
	return (
		<ModalPopup
			modalID={props.modalID}
			width={600}
			fitContent
			confirmText={_T("확인")}
			cancelText={_T("취소")}
			onConfirm={props.onConfirm}
		>
			<Typography typoSize="Title1">
				{_T("작성중인 데이터가 있습니다. 그래도 다른 메뉴로 이동하시겠습니까?")}
			</Typography>
		</ModalPopup>
	);
}
